import { Typography } from "@mui/material";
const { version } = require('../../package.json');


const AppVersion = ({color="white", isSignIn=false }) => {
  return(
    <>
    {isSignIn ? <>
      <Typography sx={{color, ml: 2}} variant="h6">
        Copyright © 2024 ASSA ABLOY
      </Typography>
      <Typography sx={{color, ml: 2, mb: 2}} variant="h6">
         v{version}
      </Typography>
      </>
      :
      <Typography sx={{color}} variant="h6">
        Copyright © 2024 ASSA ABLOY (v{version})
      </Typography>
    }
    
    </>
   
  );
}


export default AppVersion;